import React from 'react';
import SectionReveal from './ui/SectionReveal';
import PageHeader from './ui/PageHeader';
import Seo from './ui/Seo';
import { CORE_CREEDS, LINKS, PARTNER_SECTIONS } from '../data/site';

const Partners = () => (
  <main className="wrap">
    <Seo
      title="MemeFi"
      description="Welcome to MemeFi: where memes meet DeFi. Meet the protocols that integrated BOOP on Arbitrum and beyond."
      path="/memefi"
    />
    <PageHeader
      eyebrow="🐶 MEMEFI"
      title="Welcome to"
      highlight="MemeFi"
      sub="Where memes meet decentralized finance (DeFi). It's all about making finance not just something you have to deal with, but something you want to engage with, through the universal language of memes."
    />

    <section className="pt-7 lg:pt-12" aria-labelledby="creeds">
      <h2 id="creeds" className="card-title">
        Our Core Creeds
      </h2>
      <div className="grid gap-3.5 sm:grid-cols-2 lg:gap-5">
        {CORE_CREEDS.map((c, i) => (
          <SectionReveal key={c.title} delay={i * 0.05}>
            <div className="flex h-full items-start gap-3 rounded-2xl border-[3px] border-ink bg-paper px-4 py-3.5 shadow-hard lg:px-5 lg:py-5">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-[3px] border-ink bg-sun text-xl">{c.emoji}</div>
              <div>
                <h3 className="text-lg font-bold lg:text-xl">{c.title}</h3>
                <p className="mt-0.5 text-sm lg:text-[15px]">{c.body}</p>
              </div>
            </div>
          </SectionReveal>
        ))}
      </div>
    </section>

    <section className="pt-10 lg:pt-16">
      <div className="rounded-[22px] border-[3px] border-ink bg-sun px-4 py-4 shadow-hard-lg lg:px-6 lg:py-6">
        <h2 className="text-2xl font-bold leading-tight lg:text-[32px]">MemeFi Partnerships 🤝</h2>
        <p className="mt-1.5 text-[15px] font-medium lg:text-lg">
          Building the future of meme finance with our trusted partners. These projects have integrated BOOP into their DeFi platforms. Boop a
          card to visit the project.
        </p>
      </div>
    </section>

    {PARTNER_SECTIONS.map((section) => (
      <section key={section.title} className="pt-8 lg:pt-12">
        <h2 className="card-title">{section.title}</h2>
        <ul className="grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {section.partners.map((p, i) => (
            <li key={p.name}>
              <SectionReveal delay={i * 0.04} className="h-full">
                <a
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-full items-start gap-3.5 rounded-2xl border-[3px] border-ink bg-paper px-4 py-4 no-underline shadow-hard transition-transform hover:-translate-y-0.5 active:translate-x-0.5 active:translate-y-0.5 active:shadow-none"
                >
                  <span className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-2xl border-2 border-ink bg-white p-1.5">
                    <img src={p.logo} alt={`${p.name} logo`} className="h-full w-full object-contain" loading="lazy" />
                  </span>
                  <span className="min-w-0">
                    <span className="flex items-center gap-1.5 text-lg font-bold leading-tight">
                      {p.name} <span aria-hidden="true">↗</span>
                    </span>
                    <span className="mt-1 block text-sm">{p.description}</span>
                  </span>
                </a>
              </SectionReveal>
            </li>
          ))}
        </ul>
      </section>
    ))}

    <section className="pt-10 lg:pt-16">
      <div className="card card-ink text-center">
        <h2 className="card-title !text-sun">Want to become a partner?</h2>
        <p className="section-sub">Bring your protocol to the pack.</p>
        <a className="btn px-8 py-3 text-lg" href={LINKS.telegram} target="_blank" rel="noopener noreferrer">
          Contact us on Telegram
        </a>
      </div>
    </section>
  </main>
);

export default Partners;
